import { http, http_main } from '@/environment/environment';
import { WalletCredential } from '@/_models/Wallet';

class XarcadeAccountService
{
    getXarcadeUser(username: string): Promise<any> {
        return http.get(`users/${username}`);
    }

    loginUser(data: any, network: string): Promise<any> {
        if(network == 'testnet'){
            return http.put('users/login', data);
        }else{
            return http_main.put('users/login', data);
        }
        
    }

    registerUser(data: any): Promise<any> {
        return http.post('users/register', data);
    }

    forgotPassword(email: string): Promise<any> {
        return http.put(`users/forgot-password?email=${email}`);
    }

    resetPassword(userId: any, data: any): Promise<any> {
        return http.patch(`users/${userId}/reset-password`, data);
    }

    verifyRegistration(token: string): Promise<any> {
        return http.patch(`users/verifyemail/${token}`);
    }
 
    updateUserDetails(userId: string, jwtToken: string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.put(`users/${userId}`, data);
    }

    updatePassword(userId: string, jwtToken: string, oldPassword: string, newPassword: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.patch(`users/${userId}/change-password?oldPassword=${oldPassword}&newPassword=${newPassword}`);
    }

    // fetch testnet wallet
    getTestnetWallet(userId: string, jwtToken: string):Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.get(`users/${userId}/wallet`);
    }

    // fetch mainnet wallet
    getMainnetWallet(userId: string, jwtToken: string):Promise<any> {
        http_main.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http_main.get(`users/${userId}/wallet`);
    }

    updateUserWalletAddress(userId: string, jwtToken: string, publicAddress: string, network: string ): Promise<any> {
        if(network == 'testnet'){
            http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http.put(`users/${userId}/wallet?PublicAddress=${publicAddress}`);
        }else{
            http_main.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http_main.put(`users/${userId}/wallet?PublicAddress=${publicAddress}`);
        }
    }

    registerMainnetUser(userId: string, jwtToken: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.post('mainnet/user?userId='+userId);
    }
}

export default new XarcadeAccountService();